const getIsOnOpdRouteOrSignout = location =>
  location?.pathname?.includes('order-placed') ||
  location?.pathname?.includes('contracts') ||
  location?.pathname?.includes('signout');

export default getIsOnOpdRouteOrSignout;
